document.addEventListener('DOMContentLoaded', () => {

  const button = document.getElementById('fbt-add-all')
  if (!button) return

  const totalPriceEl = document.getElementById('fbt-total-price')
  const originalPriceEl = document.getElementById('fbt-original-price')

  // 从 data 属性读取国际化字符串
  const section = document.querySelector('.fbt-section')
  const i18n = {
    addToCart:    section.dataset.i18nAddToCart,
    adding:       section.dataset.i18nAdding,
    soldOut:      section.dataset.i18nSoldOut,
    error:        section.dataset.i18nError,
    networkError: section.dataset.i18nNetworkError,
  }

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2)
  }

  function updateTotal() {
    let total = 0
    let original = 0

    // 主商品
    const mainProduct = document.querySelector('.fbt-main-product')

    if (mainProduct) {
      const price = Number(mainProduct.dataset.price)
      const comparePrice = Number(mainProduct.dataset.comparePrice)

      total += price
      original += comparePrice > 0 ? comparePrice : price
    }

    // 推荐商品
    document.querySelectorAll('.fbt-checkbox:checked').forEach(el => {
      const price = Number(el.dataset.price)
      const comparePrice = Number(el.dataset.comparePrice)

      total += price
      original += comparePrice > 0 ? comparePrice : price
    })

    totalPriceEl.innerText = formatMoney(total)

    if (original > total) {
      originalPriceEl.innerText = formatMoney(original)
      originalPriceEl.style.display = 'inline'
    } else {
      originalPriceEl.innerText = ''
      originalPriceEl.style.display = 'none'
    }
  }

  function updateButton() {

    const mainSelect = document.querySelector('.fbt-main-variant-select')
    let mainAvailable = true

    if (mainSelect) {
      const selectedOption = mainSelect.options[mainSelect.selectedIndex]
      mainAvailable = !selectedOption.disabled
    }

    const checkedBoxes = document.querySelectorAll('.fbt-checkbox:checked')
    let allSoldOut = true

    if (checkedBoxes.length === 0) {
      allSoldOut = false
    } else {

      checkedBoxes.forEach(el => {

        const select = document.querySelector(
          `.fbt-variant-select[data-item-index="${el.dataset.index}"]`
        )

        if (select) {
          const selectedOption = select.options[select.selectedIndex]
          if (!selectedOption.disabled) {
            allSoldOut = false
          }
        } else {
          if (!el.disabled) {
            allSoldOut = false
          }
        }

      })

    }

    const shouldDisable = !mainAvailable || allSoldOut

    button.disabled = shouldDisable
    button.style.opacity = shouldDisable ? '0.4' : '1'
    button.style.cursor = shouldDisable ? 'not-allowed' : 'pointer'
    button.innerText = shouldDisable ? i18n.soldOut : i18n.addToCart
  }

  // 主商品变体切换
  const mainSelect = document.querySelector('.fbt-main-variant-select')

  if (mainSelect) {

    mainSelect.addEventListener('change', () => {

      const selectedOption = mainSelect.options[mainSelect.selectedIndex]
      const price = selectedOption.dataset.price
      const comparePrice = selectedOption.dataset.comparePrice

      const mainCheckbox = document.querySelector('.fbt-main-product')

      if (mainCheckbox) {
        mainCheckbox.dataset.price = price
        mainCheckbox.dataset.comparePrice = comparePrice
      }

      const priceEl = document.getElementById('fbt-main-price')
      if (priceEl) {
        priceEl.innerText = formatMoney(Number(price))
      }

      const comparePriceEl = document.getElementById('fbt-main-compare-price')
      if (comparePriceEl) {
        if (comparePrice && Number(comparePrice) > Number(price)) {
          comparePriceEl.innerText = formatMoney(Number(comparePrice))
          comparePriceEl.style.display = 'inline'
        } else {
          comparePriceEl.innerText = ''
          comparePriceEl.style.display = 'none'
        }
      }

      updateTotal()
      updateButton()
    })

  }

  // 推荐商品变体切换
  document.querySelectorAll('.fbt-variant-select').forEach(select => {

    select.addEventListener('change', () => {

      const index = select.dataset.itemIndex
      const selectedOption = select.options[select.selectedIndex]
      const price = selectedOption.dataset.price
      const comparePrice = selectedOption.dataset.comparePrice
      const variantId = selectedOption.value

      const checkbox = document.querySelector(
        `.fbt-checkbox[data-index="${index}"]`
      )

      if (checkbox) {
        checkbox.dataset.price = price
        checkbox.dataset.comparePrice = comparePrice
        checkbox.dataset.variantId = variantId
      }

      const priceEl = document.getElementById(`fbt-price-${index}`)
      if (priceEl) {
        priceEl.innerText = formatMoney(Number(price))
      }

      const comparePriceEl = document.getElementById(`fbt-compare-price-${index}`)
      if (comparePriceEl) {
        if (comparePrice && Number(comparePrice) > Number(price)) {
          comparePriceEl.innerText = formatMoney(Number(comparePrice))
          comparePriceEl.style.display = 'inline'
        } else {
          comparePriceEl.innerText = ''
          comparePriceEl.style.display = 'none'
        }
      }

      updateTotal()
      updateButton()
    })

  })

  // checkbox 切换
  document.querySelectorAll('.fbt-checkbox').forEach(el => {
    el.addEventListener('change', () => {
      updateTotal()
      updateButton()
    })
  })

  // 初始化
  updateTotal()
  updateButton()

  // 加入购物车
  button.addEventListener('click', async () => {

    if (button.disabled) return

    const items = []

    const mainSelect = document.querySelector('.fbt-main-variant-select')
    const mainVariantId = mainSelect
      ? mainSelect.value
      : document.querySelector('form [name="id"]').value

    items.push({
      id: Number(mainVariantId),
      quantity: 1
    })

    document.querySelectorAll('.fbt-checkbox:checked').forEach(el => {
      items.push({
        id: Number(el.dataset.variantId),
        quantity: 1
      })
    })

    button.innerText = i18n.adding
    button.disabled = true

    try {

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })

      if (res.ok) {
        window.location.href = '/cart'
      } else {
        const err = await res.json()
        alert(err.description || i18n.error)
        button.innerText = i18n.addToCart
        button.disabled = false
        updateButton()
      }

    } catch (e) {
      alert(i18n.networkError)
      button.innerText = i18n.addToCart
      button.disabled = false
      updateButton()
    }

  })

})